package com.iregained.site.pages

import androidx.compose.runtime.Composable
import com.iregained.site.components.cms.CmsSection
import com.iregained.site.components.cms.DynamicSectionRenderer
import com.iregained.site.components.layouts.PageLayout
import com.iregained.site.components.widgets.BackToTopButton
import com.varabyte.kobweb.compose.css.dvh
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.core.Page

@Page("/terms-of-service")
@Composable
fun TermsOfServicePage() {
    // Cleanly maps directly to the dedicated section composable
    val pageSections: List<CmsSection> = listOf(
        CmsSection.TermsOfServiceSection()
    )

    PageLayout {
        Column(
            modifier = Modifier.fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally
        ) {
            pageSections.forEach { section ->
                DynamicSectionRenderer(section)
            }
        }
        BackToTopButton()
    }
}